import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, TagIcon } from 'lucide-react';
export function BundleDealPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    // Show after 12 seconds
    const timer = setTimeout(() => {
      if (!isDismissed) {
        setIsVisible(true);
      }
    }, 12000);
    // Auto-hide after 15 seconds if not dismissed
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 23000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, [isDismissed]);
  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
  };
  return <div className="fixed top-20 right-4 sm:right-6 z-50 pointer-events-none" data-id="element-36">
      <AnimatePresence data-id="element-37">
        {isVisible && <motion.div initial={{
        opacity: 0,
        x: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: 50,
        scale: 0.9
      }} transition={{
        type: 'spring',
        damping: 20,
        stiffness: 300
      }} className="bg-brand-dark border border-brand-cyan/30 rounded-2xl p-5 max-w-xs shadow-[0_0_30px_rgba(0,102,255,0.15)] pointer-events-auto" data-id="element-38">
            {/* Close button */}
            <button onClick={handleDismiss} className="absolute top-3 right-3 text-gray-500 hover:text-white transition-colors" aria-label="Close" data-id="element-39">
              <XIcon className="w-4 h-4" data-id="element-40" />
            </button>

            {/* Header */}
            <div className="flex items-center gap-2 mb-3" data-id="element-41">
              <div className="w-8 h-8 rounded-full bg-brand-cyan/20 flex items-center justify-center" data-id="element-42">
                <TagIcon className="w-4 h-4 text-brand-cyan" data-id="element-43" />
              </div>
              <span className="font-bold text-sm text-white" data-id="element-44">
                Bundle & Save!
              </span>
            </div>

            {/* Deals */}
            <div className="space-y-2.5 mb-4" data-id="element-45">
              <div className="flex items-center justify-between gap-3 bg-brand-cyan/10 border border-brand-cyan/20 rounded-lg px-3 py-2" data-id="element-46">
                <div data-id="element-47">
                  <p className="text-xs font-bold text-white" data-id="element-48">3-Pack</p>
                  <p className="text-[10px] text-gray-400" data-id="element-49">
                    Perfect for Friends
                  </p>
                </div>
                <span className="text-sm font-black text-brand-cyan whitespace-nowrap" data-id="element-50">
                  15% OFF
                </span>
              </div>
              <div className="flex items-center justify-between gap-3 bg-yellow-400/10 border border-yellow-400/20 rounded-lg px-3 py-2" data-id="element-51">
                <div data-id="element-52">
                  <p className="text-xs font-bold text-white" data-id="element-53">5-Pack</p>
                  <p className="text-[10px] text-gray-400" data-id="element-54">
                    Built for your Squad
                  </p>
                </div>
                <span className="text-sm font-black text-yellow-400 whitespace-nowrap" data-id="element-55">
                  25% OFF
                </span>
              </div>
            </div>

            {/* CTA */}
            <a href="#pricing" onClick={handleDismiss} className="block w-full text-center py-2 rounded-lg bg-brand-cyan hover:bg-brand-sky text-brand-darkest text-xs font-bold transition-all" data-id="element-56">
              See Bundle Deals
            </a>
          </motion.div>}
      </AnimatePresence>
    </div>;
}